import { Controller } from "@hotwired/stimulus"
import { isAValue } from "web/services/helpers"

export default class RequiredInputGroupController extends Controller {
  static outlets = ["element-enabler"]
  static targets = ["requiredInput"]

  updateElementState() {
    if (this.requiredValuesFilled()) {
      this.elementEnablerOutlet.enable()
    } else {
      this.elementEnablerOutlet.disable()
    }
  }

  requiredValuesFilled() {
    return this.requiredInputTargets.every((inputElement) => {
      return isAValue(inputElement.value)
    })
  }
}
